import script from "./NewsPageThemesEditPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageThemesEditPopup.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageThemesEditPopup.vue?vue&type=style&index=0&id=5ddb9c6e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddb9c6e"]])

export default __exports__